import { createApp } from 'vue'
import App from './App.vue'

console.log = () => {}

createApp(App).mount('#app')
